import { useEffect, useState } from "react";
import { finite } from "../utils/finite";

export function useDiscountPercent(discountPercent, productPrice) {
  const [discountAmount, setDiscountAmount] = useState(0);

  useEffect(() => {
    const numberDiscountPercent = Number(discountPercent);
    const numberProductPrice = Number(productPrice);
    const p =
      finite(numberDiscountPercent) && numberDiscountPercent > 0
        ? Number(discountPercent)
        : 5;
    const price =
      finite(numberProductPrice) && numberProductPrice > 0
        ? Number(productPrice)
        : 1000;

    const amount = price * (p / 100);
    const rounded = Math.ceil(amount / 10) * 10; // 10 TL yukarı

    setDiscountAmount(rounded);
  }, [discountPercent, productPrice]);

  return discountAmount;
}
